interface TerrainMap {
  width: number;
  height: number;
  data: { [key: string]: string };
}

const TILE_COLORS: { [tileType: string]: string } = {
  grass: '#7ec850',
  forest: '#2f6b2f',
  mountain: '#8a8a8a',
  hill: '#c2a878',
  road: '#8a6d3b',
  river: '#4a90d9',
  sea: '#1b4a6b',
  beach: '#e8d4a0',
  dock: '#6b4a3a',
  fort: '#8b3a3a',
  farm: '#d4af37',
  village: '#9b59b6',
  workshop: '#e67e22',
  barracks: '#1a5276',
  windmill: '#e8d44d',
  mine: '#9e7e4a',
};

const DEFAULT_TILE_COLOR = '#444444';

const PLAYER_COLORS = ['#68b8e8', '#d43318', '#f7b728', '#5db854'];

export default function TerrainMapPreview({
  terrainMap,
  cellSize = 16,
  ownerOverrides,
  playerCount,
  highlightOwners = false,
}: {
  terrainMap: TerrainMap;
  cellSize?: number;
  ownerOverrides?: { [key: string]: number };
  playerCount?: number;
  highlightOwners?: boolean;
}) {
  const cells: {
    x: number;
    y: number;
    type: string;
    owner?: number;
  }[] = [];
  for (let y = 0; y < terrainMap.height; y++) {
    for (let x = 0; x < terrainMap.width; x++) {
      const key = `${x},${y}`;
      cells.push({
        x,
        y,
        type: terrainMap.data[key],
        owner: ownerOverrides?.[key],
      });
    }
  }

  const hasOwners = ownerOverrides && Object.keys(ownerOverrides).length > 0;
  const showLegend =
    highlightOwners &&
    playerCount !== undefined &&
    playerCount > 0 &&
    hasOwners;

  return (
    <div style={{ width: '100%' }}>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: `repeat(${terrainMap.width}, 1fr)`,
          gridTemplateRows: `repeat(${terrainMap.height}, 1fr)`,
          border: '1px solid #000',
          width: '100%',
          maxWidth: terrainMap.width * cellSize,
          aspectRatio: `${terrainMap.width} / ${terrainMap.height}`,
        }}
      >
        {cells.map(({ x, y, type, owner }) => (
          <div
            key={`${x},${y}`}
            style={{
              backgroundColor:
                TILE_COLORS[type as string] ?? DEFAULT_TILE_COLOR,
              position: 'relative',
            }}
          >
            {owner !== undefined && (
              <div
                style={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  width: '55%',
                  height: '55%',
                  borderRadius: '50%',
                  backgroundColor: PLAYER_COLORS[owner % PLAYER_COLORS.length],
                  border: '1px solid rgba(0,0,0,0.8)',
                }}
              />
            )}
          </div>
        ))}
      </div>
      {showLegend && (
        <div
          style={{
            display: 'flex',
            gap: 12,
            marginTop: 8,
            flexWrap: 'wrap',
          }}
        >
          {Array.from({ length: playerCount }, (_, i) => (
            <div
              key={i}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 4,
                fontSize: 11,
              }}
            >
              <span
                style={{
                  display: 'inline-block',
                  width: 10,
                  height: 10,
                  borderRadius: '50%',
                  backgroundColor: PLAYER_COLORS[i % PLAYER_COLORS.length],
                  border: '1px solid rgba(0,0,0,0.3)',
                }}
              />
              Player {i + 1}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
